<template>
    <div id="app">
        <Loading></Loading>
        <div class="d-block d-md-none">
            <Header></Header>
        </div>
        <div class="d-none d-md-block">
            <HeaderDesktop></HeaderDesktop>
        </div>

        <div class="content-padding">
            <router-view></router-view>
        </div>

        <Footer></Footer>

        <VerifyVignette v-if="showVerifyVignetteModal" v-model="showVerifyVignetteModal"></VerifyVignette>
    </div>
</template>

<script>

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import HeaderDesktop from './components/HeaderDesktop.vue'
import MainNavigation from './components/MainNavigation.vue'
import Loading from './components/miscellaneous/Loading.vue'
import { mapGetters, mapActions } from 'vuex'
import VerifyVignette from './components/snippets/VerifyVignette.vue';
export default {
    name: 'App',
    components: {
        Header,
        Footer,
        HeaderDesktop,
        MainNavigation,
        Loading,
        VerifyVignette
    },
    data() {
        return {
            showVerifyVignetteModal: false
        }
    },
    computed: {
        ...mapGetters({
            cart: 'cart/getCart'
        })
    },
    watch: {
        $route (to, from) {
            // document.title = to.meta.title || 'UNTRR'
        }
    },
    mounted() {
        this.removeExpiredCartItems();

        this.$eventBus.$on('openVerifyVignette', () => {
            this.openVerifyVignetteModal();
        })
    },
    methods: {
        ...mapActions({
            removeItemFromCart: 'cart/removeItemFromCart'
        }),

        removeExpiredCartItems() {
            for (let index in this.cart) {
                if(this.cart[index].type == 'vignette' && this.isDateInPast(this.cart[index].fromDate)) {
                    this.removeItemFromCart(index);
                }
            }
        },

        openVerifyVignetteModal() {
            if(process.env.VUE_APP_DEVICE == 'desktop') {
                this.showVerifyVignetteModal = true;
            }
            else {
                this.openUrl('https://www.erovinieta.ro/vgncheck/');
            }
        }
    }
}
</script>
<style lang="scss">

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;500;600;700;800&display=swap');
@import './assets/scss/_variables';

p,span,h1,h2,h3,h4,h5,h6,label,a,strong {
    font-size: 16px;
    color: #0F2443;
}

.form-group {

    label {
        font-size: 18px;
        font-weight: 500;
    }

    input {
        &[type="text"], &[type="tel"], &[type="password"]  {
            height: 50px;
        }
    }


    select {
        height: 50px;
        &.has-error {
            border: 2px solid #0F2443;
        }
        &:hover {
            border-color: #0F2443;
        }
    }

    input {
        border: 1px solid #C7C7C6;
        border-radius: 4px;
        &.has-error {
            border: 2px solid #0F2443;
        }
        &:hover {
            border-color: #0F2443;
        }
    }

    textarea {
         &.has-error {
            border: 2px solid #0F2443;
        }
        &:hover {
            border-color:#0F2443;
        }
    }

    &:last-of-type {
        margin-bottom: 0;
    }
}

#date-picker, #dp-start, #dp-end {
    height: 50px;
    background-color: white;
    background: transparent url('media/icons/datepicker.svg') no-repeat;
    background-position: calc(100% - 11px) center;
    cursor: pointer;
}

//style datepicker field if has error
//.vdp-datepicker__calendar .cell.day-header
.vdp-datepicker {
     font-size: 14px;
    .vdp-datepicker__calendar {
         .day__month_btn {
            font-weight: bold;
         }
        .cell {
            &.day-header {
                font-size: 14px;
            }
        }
    }
 &.has-error {
        border: 2px solid black;
        border-radius: 4px;
    }
}

.color-black {
    color: $black !important;
}

.p-small {
    color: $black;
    font-weight: bold;
}

.custom-link {
    color: #0F2443;
    font-weight: bold;
    text-decoration: underline;
}

//default headings
.heading {
    font-size: 54px;
    color: white;
    font-weight: 900;
    line-height: 80px;
}

.heading-medium {
    font-size: 34px;
}

.heading-small {
    font-size: 18px;
}

.heading-medium, .heading-small {
    color:$black;
    font-weight: bold;
}

.main-text {
    font-weight: bold;
    color: #0F2443;
    font-size: 22px;
}

//close button eg. closing menu on mobile
.close {
    opacity: 1;
}

//account menu (mobile)
.cont-menu {
    .wrapper {
        .or {
            padding-left: 0;
            padding-right: 0;
        }
        .access-account{
            margin-top: 66px;
            font-weight: 600;
        }

        .google-login-btn, .facebook-login-btn{
            padding: 11px 21px;
        }
    }
    .container {
        padding: 0;
    }
}
//shopping cart
.shopping-cart {
    position: relative;
    .badge-count {
        position: absolute;
        background-color: #000;
        color: white;
        padding: 3px;
        border-radius: 24px;
        width: 15px;
        height: 15px;
        text-align: center;
        padding-top: 0px;
        font-size: 10px;
        right: -10px;
    }
}


//datepicker
.vdp-datepicker__calendar{
    background-color: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 3px 6px #C7C7C6 !important;
    width: 335px;
    // display: block !important;
    padding: 10px;
    font-family: 'Montserrat', sans-serif;
    .cell{
        border: none !important;
        .day-header{
            border-bottom: 1px solid grey !important;
        }
    }
    .today{
        border: 1px solid #4D30FA !important;
        border-radius: 60px;
        color: #4D30FA;
        font-weight: bold !important;
        &:hover{
            cursor: default;
        }
    }
    .selected{
        background-color: #4D30FA !important;
        border-radius: 60px;
        color: white;
        font-weight: bold !important;
        &:hover{
            cursor: default;
        }
    }


}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{
    background-color: #4D30FA !important;
    border-radius: 60px;
    color: white;
    font-weight: bold !important;
    border: none !important;
}
#app {
    font-size: 14px;
    position: relative;
    min-height: 100vh;
    font-family: 'Montserrat', sans-serif;
}

.header-1 {
    color: #0F2443;
}

header {
    border-bottom: 1px solid #f2f1f2;
}

.default-page-paddings {
    padding-top: 130px;
    padding-bottom: 85px;
}

.default-content {
    padding-top: 50px;
}

.link {
    width: auto;
    padding: 8px 0;
    color: $dark;
    text-decoration: underline;
    font-size: 18px;
    display: inline-block;
    font-weight: bold;

    &:hover{
        color: #737880;
        cursor: pointer;
    }
}

.pointer {
    cursor: pointer;
}

.ancillary {
    opacity: 0.8;
}

.article {
    padding-bottom: 30px;

    ul {
        padding-left: 20px;
        list-style: disc;
        margin-bottom: 15px;
    }

    li {
        margin-bottom: 5px;
    }

    p {
        &:last-child {
            margin-bottom: 0px;
        }
    }
}

img {
    max-width: 100%;
}

//default containers
.container {
    max-width: 1372px;
    margin: 0 auto;
    padding: 0 18px 0px 18px;

    &.container-medium {
        max-width: 1092px;
    }
    &.container-small {
        max-width: 846px;
    }
    &.container-xs {
        max-width: 660px;
    }
}

//background
.bg-dark-blue {
    background-color: #0F2443;
}

.bg-light {
    background-color: $bg-light !important;
}
.bg-white {
    background-color: #FFFEFD;
}

.grey-text {
    opacity: 0.7;
}

.black {
    color: $black;
}

.arrow {
    display: inline-block;
    // padding: 11px 0px 13px 0px;
    .fa-arrow-left{
        font-size: 18px;
    }
    a:link {
        color: white;
        text-decoration: none;
    }
    a:visited {
        color: white;
        text-decoration: none;
    }
    a:hover {
        color: white;
        text-decoration: none;
    }
    a:active {
        color: white;
        text-decoration: none;
    }
}

.title {
    text-align: center;
    display: inline-block;
    span {
        text-align: center;
    }
}

//forms
.form-control {
    font-size: 14px;
}

label {
    font-weight: bold;
    font-size: 18px;
    color: #0F2443;
    margin-bottom: 5px;
}

select {
    display:block;
    width: 100%;
    height: 35px;
    border-radius: 5px;
    border-color: $lightgrey;
    font-size: 14px;
    -webkit-appearance: none;
    background: url('media/icons/arrow.svg') no-repeat right;
    background-position-x: calc(100% - 10px);
}
option {
    font-size: 14px;
}


.invalid-feedback {
    display: block;
    color: #0F2443;
    font-size: 14px;
    font-weight: bold;
    background: transparent url('media/icons/red-warning.svg') no-repeat;
    padding-left: 30px;
    margin-bottom: 7px;
    margin-top: 7px;
}

.warning-feedback {
    color: #0F2443;
    background: transparent url('media/icons/info.svg') no-repeat;
    background-position: top;
    background-position-x: left;
    padding-left: 29px;
    margin-top: 10px;
}


//cards
 .item-card {
    margin: 15px 0;
}
.card {
    margin-bottom: 0;
    text-align: center;
    background: transparent;
    height: 100%;
    padding: 10px;
    .subtitle {
        line-height: 20px;
        font-weight: 600;
    }
    .card-header {
        padding: 0px 5px;
    }

    .card-body {
        padding: 5px;
    }

    &.card-pointer {
        cursor: pointer;
    }

    &.card-primary {

        border: solid 1px $green;

        .card-header {
            background: $green;
            color: #fff;
        }
    }

    .lower-padding {
        padding: 5px 0px;
    }
    .lower-bottom-margin {
        margin-bottom: 0px;
    }
    .amount {
        color: #929292;
    }
    .card-title {
        font-size: 14px;
        margin-bottom: 5px;
    }
    .number-of-passes {
        font-size: 24px;
        font-weight: bold;
    }

    a:link {
        color: white;
        text-decoration: none;
    }
    a:visited {
        color: white;
        text-decoration: none;
    }
    a:hover {
        color: white;
        text-decoration: none;
    }
    a:active {
        color: white;
        text-decoration: none;
    }
     .img-wrapper {
        padding: 15px 0;
    }
}

//checkboxs confirmation (payment method and NewAccount)

.confirmation {
    label {
        display: inline-block;
        word-wrap: break-word;
        white-space: normal;
    }
    input {
        margin-top: 15px;
        margin-right: 5px;
        display: inline-block;
    }
}

//remove margin added by last p inside accordion
.question-wrapper {
    .answer {
        p {
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

.grey {
    color: #737880;
}

@media only screen and (max-width: 600px) {
    .confirmation {
        form {
            label {
                max-width: 300px;
            }
        }
    }
    .payment-method {
        span {
            width: 300px;
        }
    }

    .header-1{
        color: #0F2443;
    }
}

//button
.action-button {

    .btn {

        width: 100%;
        padding: 5px 0px;
        margin-top: 8.5px;
        margin-bottom: 8.5px;
        border-color: $green;
        font-size: 14px;

        &.btn-light {
            color: $green;
            background: white;
        }

        &.btn-primary {
            background-color: $green;
        }
        &.btn-primary:hover {
            border-color: $green;
        }
        &.btn-primary:not(:disabled):not(.disabled):active {
            border-color: $green;
            background-color: $green;
        }
        &.btn-primary:focus {
            border-color: $green;
        }
    }

    @media only screen and (min-width: 600px) {
        &.action-button-big-desktop {
            .btn {
                padding: 15px 5px;
            }
        }
    }
}
.main-btn{
    border: 2px solid $black;
    width: 100%;
    padding: 9px 22px;
    border-radius: 4px;
    color: $black;
    text-decoration: none;
    background-color: transparent;
    font-size: 18px;
    display: inline-block;
    text-align: center;
    font-weight: bold;
    cursor: pointer;

    &.disabled {
        opacity: 0.5;
    }

    &:not(.disabled):hover{
        background-color: $black;
        color: white;
        text-decoration: none !important;
        span {
            color: white;
        }
    }

    &.warning {
        color:chocolate !important;
        border: 2px solid chocolate;

        span {
            color: chocolate !important;
        }

        &:hover {
            background-color: chocolate;
            color: white !important;

            span {
                color: white !important;
            }
        }
    }
}

.elipse-complete{
    height: 30px;
    width: 30px;
    background-color: #0F2443;
    border-radius: 30px;
    color: white;
    padding: 8px 5px;
    margin-right: 5px;
}
.btn-purple{
    background-color: #3F24E2;
    font-size: 22px;
    background-color: $accent-color;
    color: white;
    border-radius: 4px;
    border: none;
    text-align: center;
    font-weight: bold;
    &:hover{
        color: white;
        background-color: #4d30fa;
        text-decoration: none;
    }
}

.btn-header {
    color: white;
    background-color: #636175;
    text-decoration: none;
    font-size: 14px;

    @media only screen and (max-width: 768px) {
        margin: 10px;
    }

    &:hover{
        color: white;
        text-decoration: underline;
    }
}

.next-step{
    font-weight: bold;
    float: right;
    font-size: 18px;
    padding: 16.5px 0px;
}

.dark-bar {
    .danger-sign-icon {
        margin-right: 10px;
    }
    span {
        color: white;
        font-weight: bold;
        font-size: 14px;
        text-decoration: underline;
        &:hover {
            color:#F3F2EF;
            cursor: pointer;
        }
    }
}

//bottom bar negru, general
.bottom-bar {
    > div {
        width: 100%;
        background-color: $dark;
        bottom: 0px;
        position: fixed;
        min-height: 50px;
        z-index: 2000;
        p {
            font-size: 12px;
            margin-bottom:2px;
            color: white;
        }
        #adding-top-margin-to-p {
            margin-top: 2px;
        }
    }

    &::before {
        content: " ";
        height: 80px;
        width: 100%;
        display: block;
    }
}

//bottom bar for my account
.account-bottom-bar {
    width: 100%;
    background-color: #ebebeb;
    bottom: 0px;
    position: fixed;

    .action-button {
        button {
            width: 100%;
            padding: 5px 0px;
            margin-top: 8.5px;
            margin-bottom: 8.5px;
            background-color: $green;
            border-color: $green;
            font-size: 14px;
        }
    }
}
//modals
    .modal-content {
        padding: 40px;
        .modal-header {
            border: none;
            padding: 0;
            .close {
                padding: 0;
                margin: -20px;
            }
        }
        .modal-body{
            overflow-y: auto;
            max-height: 500px;
            .container{
                padding: 0;
            }
            .default-page-paddings {
                padding: 0;
            }
        }
    }

//general
a {
    text-decoration: underline;
    color: #10284B;
    &:hover {
        color: #737880;
    }
}
.padding-20 {
    padding: 20px 0;
}

.dropdown-item.active, .dropdown-item:active {
    background-color: #EEEDEC;
}
.dropdown-menu {
   border-color: #0F2443;
   min-width: 200px;
   padding: 18px 5px;
   background-color: #FAF9F6;
    &:after, &:before {
    bottom: 100%;
    left: 11%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

&:after {
    border-color: rgba(250, 249, 246, 0);
    border-bottom-color: #FAF9F6;
    border-width: 7px;
    margin-left: -7px;
}

&:before {
    border-color: rgba(15, 36, 67, 0);
    border-bottom-color: #0F2443;
    border-width: 8px;
    margin-left: -8px;
}
}
.remove-a {
    a:link {
        color: black;
        text-decoration: none;
    }
    a:visited {
        color: black;
        text-decoration: none;
    }
    a:hover {
        color: black;
        text-decoration: none;
    }
    a:active {
        color: black;
        text-decoration: none;
    }
}

//for tabs
.bottom-border {
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: $lightgrey;
    margin-bottom: -2px;
    height: 52px;
    background-color: white;
}

.border-primary {
    border-color: $green !important;
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
}

.language-hover {
    min-width: 130px;
    cursor: pointer;
    padding: 5px 10px 5px 10px;

    span {
        font-size: 13px;
        margin-right: 5px;
    }
    &:hover {
        background-color: #EEEDEC;
        border-radius: 25px;
        position: relative;
        &::after {
            content: url('media/icons/arrow.svg');
        }
    }
}

.opened {
    .language-hover {
        &:hover{
            &:after {
                content: url('media/icons/arrow_opened.svg');
            }
        }
    }
}

@media only screen and (max-width: 768px) {
    .language-hover {
        span {
            font-size: 16px;
        }
        &::after {
            content: url('media/icons/arrow.svg');
        }
    }
    .opened {
        .language-hover {
            &:after {
                content: url('media/icons/arrow_opened.svg');
            }
        }
    }
    .default-page-paddings {
        padding-top: 35px;
        padding-bottom: 55px;
    }
    .default-content {
        padding-top: 35px;
    }
    //cards
    .card {
        .subtitle {
            font-size: 14px;
        }
    }
    .item-card {
        margin: 10px 0;
        &:nth-child(even) {
            padding-left: 10px;
        }
        &:nth-child(odd) {
            padding-right: 10px;
        }
    }
    .main-btn {
        border: 2px solid $dark;
        width: 100%;
        padding: 8.5px 13px;
        border-radius: 4px;
        color: $dark;
        text-decoration: none;
        background-color: transparent;
        font-size: 18px;
        display: inline-block;
        text-align: center;
        font-weight: bold;
    }
}

.icon{
    background-size: contain;
    background-repeat: no-repeat;
    margin: 0;
    background-position: center;
}
.comands-history-icon{
    background-image:url('media/icons/company_benefits/comands-history.svg');
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.many-profiles-icon{
    background-image:url('media/icons/company_benefits/many-profiles.svg');
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.multiple-comands-icon{
    background-image:url('media/icons/company_benefits/multiple-comands.svg');
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.rovignette-status-icon{
    background-image:url('media/icons/company_benefits/rovignette-status.svg');
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.need-help-icon{
    background-image:url('media/icons/company_benefits/need-help.svg');
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.flota-auto-icon{
    background-image:url('media/icons/company_benefits/flota-auto.svg');
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
}
.warning-icon{
    background-image:url('media/icons/cart/warning-sign.svg');
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
}
.icon-x{
    background-image:url('media/icons/cart/x.svg');
    background-repeat: no-repeat;
    width: 38px;
    height: 38px;
}
.edit-icon{
    background-image:url('media/icons/cart/edit.svg');
    background-repeat: no-repeat;
    width: 17px;
    height: 17px;
    display: block;
}
.delete-icon{
    background-image:url('media/icons/cart/delete.svg');
    background-repeat: no-repeat;
    width: 17px;
    height: 17px;
    display: block;
}

.languages {
    .icon {
        width: 26px;
        height: 26px;
    }
}
.language-ro{
    background-image:url('media/icons/languages/ro.svg');
}
.language-en {
    background-image:url('media/icons/languages/en.svg');
}
.language-de {
    background-image:url('media/icons/languages/de.svg');
}
.language-bg {
    background-image:url('media/icons/languages/bg.svg');
}
.language-hu {
    background-image:url('media/icons/languages/hu.svg');
}
.language-pl {
    background-image:url('media/icons/languages/pl.svg');
}
.language-ru {
    background-image:url('media/icons/languages/ru.svg');
}
.language-sr {
    background-image:url('media/icons/languages/rs.svg');
}
.language-tr {
    background-image:url('media/icons/languages/tr.svg');
}
.language-ua {
    background-image:url('media/icons/languages/ua.svg');
}
.person-icon{
    width: 20px;
    height: 20px;
    background-image:url('media/icons/header/person.svg');
}
.hamburger-icon{
    width: 21.523px;
    height: 15.617px;
    background-image:url('media/icons/header/hamburger.svg');
}
.profile-icon{
    width: 18px;
    height: 20.31px;
    background-image:url('media/icons/header/profile.svg');
}
.x-icon{
    width: 20px;
    height: 20.14px;
    background-image:url('media/icons/header/x.svg');
}
.v-icon{
    width: 20px;
    height: 15px;
    background-image:url('media/icons/e-rovinieta/v-icon.svg');
}
.cart-icon{
    width: 20px;
    height: 20px;
    background-image:url('media/icons/header/cart.svg');
}
.authorized-distributor-icon{
    width: 18pt;
    height: 16pt;
    background-image:url('media/icons/header/distribuitor_autorizat.svg');
}
.google-icon{
    width: 40px;
    height: 26px;
    background-image:url('media/icons/login/google.svg');
    background-repeat: no-repeat;
}
.facebook-icon{
    width: 40px;
    height: 26px;
    background-image:url('media/icons/login/facebook.svg');
    background-repeat: no-repeat;
}
.arrow-icon{
    width: 13.65px;
    height: 20.61px;
    background-image: url('media/icons/header/ic_sageata.svg');
}

.google-login-btn,
.facebook-login-btn,
.apple-login-btn {
    border: 2px solid #0F2443;
    width: 100%;
    padding: 8px 15px;
    border-radius: 4px;
    text-decoration: none;
    font-size: 18px;
    display: inline-block;
    text-align: center;
    display: flex;
    align-items: center;

    span {
        flex-grow: 1;
        padding-left: 26px;
    }

    &:hover {
        background-color: #0F2443;

        span {
            color: white;
        }
    }
}

.google-login-btn, .facebook-login-btn, .apple-login-btn {
    background-color: transparent;
    font-weight: bold;
    background-position: left 15px bottom 8px;
    background-repeat: no-repeat;
    background-position-y: center;
    span {
        padding-left: 26px;
    }
}
.google-login-btn {
    background-image:url('media/icons/login/google.svg');
}

.facebook-login-btn {
    background-image:url('media/icons/login/facebook.svg');
}

.apple-login-btn {
    background-image:url('media/icons/login/apple.svg');

    &:hover {
        background-image:url('media/icons/login/apple-white.svg');
    }
}

/* ICONS STEPS SECTION - HOMEPAGE */
.add-cart-icon{
    width: 35px;
    height: 33px;
    background-image:url('media/icons/sectiune_pasi/add_cart.svg');
}
.card-payment-icon{
    width: 40px;
    height: 26px;
    background-image:url('media/icons/sectiune_pasi/card_payment.svg');
}
.semafor-icon{
    width: 20px;
    height: 38px;
    background-image:url('media/icons/sectiune_pasi/semafor.svg');
}
.verifici-valabilitate-icon{
    width: 35px;
    height: 32px;
    background-image:url('media/icons/sectiune_pasi/verifici_valabilitate.svg');
}
.salveaza-datele-icon{
    width: 55px;
    height: 40px;
    background-image:url('media/icons/sectiune_pasi/salveaza_datele.svg');
}
.livrare-email-sms-icon{
    width: 31px;
    height: 32px;
    background-image:url('media/icons/sectiune_pasi/livrare_email_sms.svg');
}

.card-icon{
    width: 35px;
    height: 30px;
    background-image:url('media/icons/sectiune_pasi/card.svg');
    z-index: 1;
}
.invoice-icon{
    width: 31px;
    height: 31px;
    background-image:url('media/icons/sectiune_pasi/invoice.svg');
    z-index: 2;
}

.notificare-expirare-icon{
    width: 35px;
    height: 30px;
    background-image:url('media/icons/sectiune_pasi/notificare_expirare.svg');
}
.servicii-profesioniste-icon{
    width: 31px;
    height: 31px;
    background-image:url('media/icons/sectiune_pasi/servicii_profesioniste.svg');
}
.finder-icon{
    width: 31px;
    height: 31px;
    background-image:url('media/icons/distribuitor_autorizat/finder.svg');
}
/* ICONS E-ROVINIETA SECTION - E-ROVINIETA PAGE */
.e-rovinieta-icon{
    width: 156px;
    height: 17.89px;
    background-image:url('media/icons/e-rovinieta/e-rovinieta.svg');

    @media only screen and (max-width: 768px) {
        width: 130px;
    }
}
.bridge-fee-icon{
    width: 156px;
    height: 17.89px;
    background-image:url('media/icons/tpf/bridge-fee-Fetesti.svg');

    @media only screen and (max-width: 768px) {
        width: 130px;
    }
}
.danger-sign-icon{
    width: 20px;
    height: 20px;
    background-image:url('media/icons/e-rovinieta/danger-sign.svg');
}
.autoturisme-icon{
    width: 106px;
    height: 45px;
    background-image:url('media/icons/e-rovinieta/autoturisme.svg');
}

.profiles-icon {
    width: 21px;
    height: 22px;
    background-image:url('media/icons/account/profiles.svg');
    background-repeat: no-repeat;
}

.account-icon {
    width: 21px;
    height: 22px;
    background-image:url('media/icons/account/account.svg');
    background-repeat: no-repeat;
}

.vehicles-icon {
    width: 25px;
    height: 22px;
    background-image:url('media/icons/account/vehicles.svg');
    background-repeat: no-repeat;
}

.orders-icon {
    width: 21px;
    height: 22px;
    background-image:url('media/icons/account/orders.svg');
    background-repeat: no-repeat;
}

.cat-icon {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 44px;
    margin: 0 auto;
    width: 100%;
}
.cat1-icon {
    background-image:url('media/icons/tpf/cat1.svg');
}

.cat2-icon {
    background-image:url('media/icons/tpf/cat2.svg');
}

.cat3-icon {
    background-image:url('media/icons/tpf/cat3.svg');
}

.cat4-icon {
    background-image:url('media/icons/tpf/cat4.svg');
}

.cata-icon {
    background-image:url('media/icons/erov/catA.svg');
}

.catb-icon {
    background-image:url('media/icons/erov/catB.svg');
}

.catc-icon {
    background-image:url('media/icons/erov/catC.svg');
}

.catd-icon {
    background-image:url('media/icons/erov/catD.svg');
}

.cate-icon {
    background-image:url('media/icons/erov/catE.svg');
}

.catf-icon {
    background-image:url('media/icons/erov/catF.svg');
}

.catg-icon {
    background-image:url('media/icons/erov/catG.svg');
}

.cath-icon {
    background-image:url('media/icons/erov/catH.svg');
}

//accordion with questions
.section-frequent-questions {
    background-color: #FAF9F6;
    padding-top: 50px;
    padding-bottom: 100px;

    a {
    }
}

//router-link
.categories {
    .card {
        margin-bottom: 0;
        border-top: solid 3px $dark;
        min-height: 100px;

        &:hover {
            border-color: $green;
            .cat1-icon {
                background-image:url('media/icons/tpfColor/cat1.svg');
            }
            .cat2-icon {
                background-image:url('media/icons/tpfColor/cat2.svg');
            }
            .cat3-icon {
                background-image:url('media/icons/tpfColor/cat3.svg');
            }
            .cat4-icon {
                background-image:url('media/icons/tpfColor/cat4.svg');
            }
            .cata-icon {
                background-image:url('media/icons/erovColor/catA.svg');
            }

            .catb-icon {
                background-image:url('media/icons/erovColor/catB.svg');
            }

            .catc-icon {
                background-image:url('media/icons/erovColor/catC.svg');
            }

            .catd-icon {
                background-image:url('media/icons/erovColor/catD.svg');
            }

            .cate-icon {
                background-image:url('media/icons/erovColor/catE.svg');
            }

            .catf-icon {
                background-image:url('media/icons/erovColor/catF.svg');
            }

            .catg-icon {
                background-image:url('media/icons/erovColor/catG.svg');
            }

            .cath-icon {
                background-image:url('media/icons/erovColor/catH.svg');
            }
        }

        .lower-padding {
            padding: 5px 0px;
        }
        .lower-bottom-margin {
            margin-bottom: 0px;
        }
        .amount {
            font-size: 22px;
            color: #929292;
            white-space: nowrap;
        }

        .card-text {
            line-height: 14px;
            word-break: break-word;
            color: #0F2443;
        }
    }
    a:link {
        font-size: 14px;
        color: black;
        text-decoration: none;
    }

    /* visited link */
    a:visited {
        font-size: 14px;
        color: black;
        text-decoration: none;
    }

    /* mouse over link */
    a:hover {
        font-size: 14px;
        color: black;
        text-decoration: none;
    }

    /* selected link */
    a:active {
        font-size: 14px;
        color: black;
        text-decoration: none;

    }
}

.overlay-back {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 3000;
}

.content-padding {
    padding-top: 91px;
    background: #FAF9F6;
}

.login-section {
    padding-top: 60px;
    padding-bottom: 60px;
    background-color: #EEEDEC;
    position:relative;
    margin-bottom: 20px;
    margin-top: 20px;
}

@media only screen and (max-width: 768px) {
    .content-padding {
        padding-top: 60px;
    }
    //default heading on mobile
    .heading {
        font-size: 30px;
        line-height: 44px;
        padding: 0;
    }

    .heading-medium {
        font-size: 26px;
    }

    .heading-small {
        font-size: 18px;
        line-height: 22px;
    }
    .main-text {
        font-size: 18px;
    }
    //accordion with questions
    .section-frequent-questions {
        padding-top: 30px;

        padding-bottom: 55px;
        a {
            padding-left: 0;
        }
    }
}

.VueCarousel-pagination {
    margin-top: 0px !important;

    .VueCarousel-dot-container {
        margin-top: 0px !important;
    }
}

.p-relative {
    position: relative;
}

</style>
